import store from "../store";
export default {
  install(Vue) {
    //清空表单数据
    Vue.prototype.resetForm = function (formName, obj) {
      if (this.$refs[formName]) {
        this.$refs[formName].resetFields();
      }
      Object.keys(obj).forEach((key) => {
        obj[key] = "";
      });
    };

    //快速复制obj，快速把obj1里面对应的数据复制到obj2
    Vue.prototype.objCopy = function (obj1, obj2) {
      Object.keys(obj2).forEach((key) => {
        obj2[key] = obj1[key];
      });
    };

    //判断按钮权限
    Vue.prototype.hasPermission = function (params) {
      let hasTag = false;
      let permissionList = store.state.userPermissions;
      for (let i = 0; i < permissionList.length; i++) {
        if (permissionList[i] === params) {
          hasTag = true;
        }
      }
      return hasTag;
    }; //表格数据流下载

    Vue.prototype.downloadExcel = function (res, name) {
      // res就是接口返回的文件流了; 定义请求的接口时需标明responseType: 'blob',//将文件流转成blob对象
      let objectUrl = window.URL.createObjectURL(new Blob([res]));
      const elink = document.createElement("a");
      elink.download = `${name}信息导出.xls`; //下载文件名称,
      elink.style.display = "none";
      elink.href = objectUrl;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
      window.URL.revokeObjectURL(elink.href); // 释放URL 对象 // elink.href
    };
  },
};
